import { createContext as qe, useEffect as F, useRef as Ye, useContext as We, useState as J } from "react";
import { g as Me } from "./_commonjsHelpers-10dfc225.js";
var de = {};
de.match = Qe;
de.parse = Ae;
var Ue = /(?:(only|not)?\s*([^\s\(\)]+)(?:\s*and)?\s*)?(.+)?/i, Fe = /\(\s*([^\s\:\)]+)\s*(?:\:\s*([^\s\)]+))?\s*\)/, Ne = /^(?:(min|max)-)?(.+)/, ze = /(em|rem|px|cm|mm|in|pt|pc)?$/, He = /(dpi|dpcm|dppx)?$/;
function Qe(e, t) {
  return Ae(e).some(function(n) {
    var i = n.inverse, u = n.type === "all" || t.type === n.type;
    if (u && i || !(u || i))
      return !1;
    var c = n.expressions.every(function(l) {
      var d = l.feature, R = l.modifier, f = l.value, p = t[d];
      if (!p)
        return !1;
      switch (d) {
        case "orientation":
        case "scan":
          return p.toLowerCase() === f.toLowerCase();
        case "width":
        case "height":
        case "device-width":
        case "device-height":
          f = be(f), p = be(p);
          break;
        case "resolution":
          f = he(f), p = he(p);
          break;
        case "aspect-ratio":
        case "device-aspect-ratio":
        case /* Deprecated */
        "device-pixel-ratio":
          f = me(f), p = me(p);
          break;
        case "grid":
        case "color":
        case "color-index":
        case "monochrome":
          f = parseInt(f, 10) || 1, p = parseInt(p, 10) || 0;
          break;
      }
      switch (R) {
        case "min":
          return p >= f;
        case "max":
          return p <= f;
        default:
          return p === f;
      }
    });
    return c && !i || !c && i;
  });
}
function Ae(e) {
  return e.split(",").map(function(t) {
    t = t.trim();
    var n = t.match(Ue), i = n[1], u = n[2], c = n[3] || "", l = {};
    return l.inverse = !!i && i.toLowerCase() === "not", l.type = u ? u.toLowerCase() : "all", c = c.match(/\([^\)]+\)/g) || [], l.expressions = c.map(function(d) {
      var R = d.match(Fe), f = R[1].toLowerCase().match(Ne);
      return {
        modifier: f[1],
        feature: f[2],
        value: R[2]
      };
    }), l;
  });
}
function me(e) {
  var t = Number(e), n;
  return t || (n = e.match(/^(\d+)\s*\/\s*(\d+)$/), t = n[1] / n[2]), t;
}
function he(e) {
  var t = parseFloat(e), n = String(e).match(He)[1];
  switch (n) {
    case "dpcm":
      return t / 2.54;
    case "dppx":
      return t * 96;
    default:
      return t;
  }
}
function be(e) {
  var t = parseFloat(e), n = String(e).match(ze)[1];
  switch (n) {
    case "em":
      return t * 16;
    case "rem":
      return t * 16;
    case "cm":
      return t * 96 / 2.54;
    case "mm":
      return t * 96 / 2.54 / 10;
    case "in":
      return t * 96;
    case "pt":
      return t * 72;
    case "pc":
      return t * 72 / 12;
    default:
      return t;
  }
}
var Ve = de.match, Ee = typeof window < "u" ? window.matchMedia : null;
function Ke(e, t, n) {
  var i = this, u;
  Ee && !n && (u = Ee.call(window, e)), u ? (this.matches = u.matches, this.media = u.media, u.addListener(d)) : (this.matches = Ve(e, t), this.media = e), this.addListener = c, this.removeListener = l, this.dispose = R;
  function c(f) {
    u && u.addListener(f);
  }
  function l(f) {
    u && u.removeListener(f);
  }
  function d(f) {
    i.matches = f.matches, i.media = f.media;
  }
  function R() {
    u && u.removeListener(d);
  }
}
function Je(e, t, n) {
  return new Ke(e, t, n);
}
var Xe = Je;
const Ge = /* @__PURE__ */ Me(Xe);
var Ze = /[A-Z]/g, Be = /^ms-/, oe = {};
function er(e) {
  return "-" + e.toLowerCase();
}
function Ie(e) {
  if (oe.hasOwnProperty(e))
    return oe[e];
  var t = e.replace(Ze, er);
  return oe[e] = Be.test(t) ? "-" + t : t;
}
function rr(e, t) {
  if (e === t)
    return !0;
  if (!e || !t)
    return !1;
  const n = Object.keys(e), i = Object.keys(t), u = n.length;
  if (i.length !== u)
    return !1;
  for (let c = 0; c < u; c++) {
    const l = n[c];
    if (e[l] !== t[l] || !Object.prototype.hasOwnProperty.call(t, l))
      return !1;
  }
  return !0;
}
var le = { exports: {} }, K = { exports: {} }, x = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Te;
function tr() {
  if (Te)
    return x;
  Te = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, i = e ? Symbol.for("react.fragment") : 60107, u = e ? Symbol.for("react.strict_mode") : 60108, c = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, d = e ? Symbol.for("react.context") : 60110, R = e ? Symbol.for("react.async_mode") : 60111, f = e ? Symbol.for("react.concurrent_mode") : 60111, p = e ? Symbol.for("react.forward_ref") : 60112, w = e ? Symbol.for("react.suspense") : 60113, C = e ? Symbol.for("react.suspense_list") : 60120, M = e ? Symbol.for("react.memo") : 60115, L = e ? Symbol.for("react.lazy") : 60116, P = e ? Symbol.for("react.block") : 60121, $ = e ? Symbol.for("react.fundamental") : 60117, k = e ? Symbol.for("react.responder") : 60118, z = e ? Symbol.for("react.scope") : 60119;
  function I(a) {
    if (typeof a == "object" && a !== null) {
      var W = a.$$typeof;
      switch (W) {
        case t:
          switch (a = a.type, a) {
            case R:
            case f:
            case i:
            case c:
            case u:
            case w:
              return a;
            default:
              switch (a = a && a.$$typeof, a) {
                case d:
                case p:
                case L:
                case M:
                case l:
                  return a;
                default:
                  return W;
              }
          }
        case n:
          return W;
      }
    }
  }
  function A(a) {
    return I(a) === f;
  }
  return x.AsyncMode = R, x.ConcurrentMode = f, x.ContextConsumer = d, x.ContextProvider = l, x.Element = t, x.ForwardRef = p, x.Fragment = i, x.Lazy = L, x.Memo = M, x.Portal = n, x.Profiler = c, x.StrictMode = u, x.Suspense = w, x.isAsyncMode = function(a) {
    return A(a) || I(a) === R;
  }, x.isConcurrentMode = A, x.isContextConsumer = function(a) {
    return I(a) === d;
  }, x.isContextProvider = function(a) {
    return I(a) === l;
  }, x.isElement = function(a) {
    return typeof a == "object" && a !== null && a.$$typeof === t;
  }, x.isForwardRef = function(a) {
    return I(a) === p;
  }, x.isFragment = function(a) {
    return I(a) === i;
  }, x.isLazy = function(a) {
    return I(a) === L;
  }, x.isMemo = function(a) {
    return I(a) === M;
  }, x.isPortal = function(a) {
    return I(a) === n;
  }, x.isProfiler = function(a) {
    return I(a) === c;
  }, x.isStrictMode = function(a) {
    return I(a) === u;
  }, x.isSuspense = function(a) {
    return I(a) === w;
  }, x.isValidElementType = function(a) {
    return typeof a == "string" || typeof a == "function" || a === i || a === f || a === c || a === u || a === w || a === C || typeof a == "object" && a !== null && (a.$$typeof === L || a.$$typeof === M || a.$$typeof === l || a.$$typeof === d || a.$$typeof === p || a.$$typeof === $ || a.$$typeof === k || a.$$typeof === z || a.$$typeof === P);
  }, x.typeOf = I, x;
}
var S = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ge;
function nr() {
  return ge || (ge = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, i = e ? Symbol.for("react.fragment") : 60107, u = e ? Symbol.for("react.strict_mode") : 60108, c = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, d = e ? Symbol.for("react.context") : 60110, R = e ? Symbol.for("react.async_mode") : 60111, f = e ? Symbol.for("react.concurrent_mode") : 60111, p = e ? Symbol.for("react.forward_ref") : 60112, w = e ? Symbol.for("react.suspense") : 60113, C = e ? Symbol.for("react.suspense_list") : 60120, M = e ? Symbol.for("react.memo") : 60115, L = e ? Symbol.for("react.lazy") : 60116, P = e ? Symbol.for("react.block") : 60121, $ = e ? Symbol.for("react.fundamental") : 60117, k = e ? Symbol.for("react.responder") : 60118, z = e ? Symbol.for("react.scope") : 60119;
    function I(o) {
      return typeof o == "string" || typeof o == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      o === i || o === f || o === c || o === u || o === w || o === C || typeof o == "object" && o !== null && (o.$$typeof === L || o.$$typeof === M || o.$$typeof === l || o.$$typeof === d || o.$$typeof === p || o.$$typeof === $ || o.$$typeof === k || o.$$typeof === z || o.$$typeof === P);
    }
    function A(o) {
      if (typeof o == "object" && o !== null) {
        var Y = o.$$typeof;
        switch (Y) {
          case t:
            var V = o.type;
            switch (V) {
              case R:
              case f:
              case i:
              case c:
              case u:
              case w:
                return V;
              default:
                var ve = V && V.$$typeof;
                switch (ve) {
                  case d:
                  case p:
                  case L:
                  case M:
                  case l:
                    return ve;
                  default:
                    return Y;
                }
            }
          case n:
            return Y;
        }
      }
    }
    var a = R, W = f, X = d, G = l, Z = t, B = p, H = i, ee = L, re = M, N = n, te = c, q = u, U = w, Q = !1;
    function ne(o) {
      return Q || (Q = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), r(o) || A(o) === R;
    }
    function r(o) {
      return A(o) === f;
    }
    function s(o) {
      return A(o) === d;
    }
    function b(o) {
      return A(o) === l;
    }
    function m(o) {
      return typeof o == "object" && o !== null && o.$$typeof === t;
    }
    function y(o) {
      return A(o) === p;
    }
    function E(o) {
      return A(o) === i;
    }
    function v(o) {
      return A(o) === L;
    }
    function h(o) {
      return A(o) === M;
    }
    function T(o) {
      return A(o) === n;
    }
    function _(o) {
      return A(o) === c;
    }
    function g(o) {
      return A(o) === u;
    }
    function D(o) {
      return A(o) === w;
    }
    S.AsyncMode = a, S.ConcurrentMode = W, S.ContextConsumer = X, S.ContextProvider = G, S.Element = Z, S.ForwardRef = B, S.Fragment = H, S.Lazy = ee, S.Memo = re, S.Portal = N, S.Profiler = te, S.StrictMode = q, S.Suspense = U, S.isAsyncMode = ne, S.isConcurrentMode = r, S.isContextConsumer = s, S.isContextProvider = b, S.isElement = m, S.isForwardRef = y, S.isFragment = E, S.isLazy = v, S.isMemo = h, S.isPortal = T, S.isProfiler = _, S.isStrictMode = g, S.isSuspense = D, S.isValidElementType = I, S.typeOf = A;
  }()), S;
}
var Oe;
function $e() {
  return Oe || (Oe = 1, process.env.NODE_ENV === "production" ? K.exports = tr() : K.exports = nr()), K.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var ae, Re;
function or() {
  if (Re)
    return ae;
  Re = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function i(c) {
    if (c == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(c);
  }
  function u() {
    try {
      if (!Object.assign)
        return !1;
      var c = new String("abc");
      if (c[5] = "de", Object.getOwnPropertyNames(c)[0] === "5")
        return !1;
      for (var l = {}, d = 0; d < 10; d++)
        l["_" + String.fromCharCode(d)] = d;
      var R = Object.getOwnPropertyNames(l).map(function(p) {
        return l[p];
      });
      if (R.join("") !== "0123456789")
        return !1;
      var f = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(p) {
        f[p] = p;
      }), Object.keys(Object.assign({}, f)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return ae = u() ? Object.assign : function(c, l) {
    for (var d, R = i(c), f, p = 1; p < arguments.length; p++) {
      d = Object(arguments[p]);
      for (var w in d)
        t.call(d, w) && (R[w] = d[w]);
      if (e) {
        f = e(d);
        for (var C = 0; C < f.length; C++)
          n.call(d, f[C]) && (R[f[C]] = d[f[C]]);
      }
    }
    return R;
  }, ae;
}
var ie, xe;
function pe() {
  if (xe)
    return ie;
  xe = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return ie = e, ie;
}
var se, Se;
function je() {
  return Se || (Se = 1, se = Function.call.bind(Object.prototype.hasOwnProperty)), se;
}
var ce, _e;
function ar() {
  if (_e)
    return ce;
  _e = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = pe(), n = {}, i = je();
    e = function(c) {
      var l = "Warning: " + c;
      typeof console < "u" && console.error(l);
      try {
        throw new Error(l);
      } catch {
      }
    };
  }
  function u(c, l, d, R, f) {
    if (process.env.NODE_ENV !== "production") {
      for (var p in c)
        if (i(c, p)) {
          var w;
          try {
            if (typeof c[p] != "function") {
              var C = Error(
                (R || "React class") + ": " + d + " type `" + p + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof c[p] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw C.name = "Invariant Violation", C;
            }
            w = c[p](l, p, R, d, null, t);
          } catch (L) {
            w = L;
          }
          if (w && !(w instanceof Error) && e(
            (R || "React class") + ": type specification of " + d + " `" + p + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof w + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), w instanceof Error && !(w.message in n)) {
            n[w.message] = !0;
            var M = f ? f() : "";
            e(
              "Failed " + d + " type: " + w.message + (M ?? "")
            );
          }
        }
    }
  }
  return u.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, ce = u, ce;
}
var ue, we;
function ir() {
  if (we)
    return ue;
  we = 1;
  var e = $e(), t = or(), n = pe(), i = je(), u = ar(), c = function() {
  };
  process.env.NODE_ENV !== "production" && (c = function(d) {
    var R = "Warning: " + d;
    typeof console < "u" && console.error(R);
    try {
      throw new Error(R);
    } catch {
    }
  });
  function l() {
    return null;
  }
  return ue = function(d, R) {
    var f = typeof Symbol == "function" && Symbol.iterator, p = "@@iterator";
    function w(r) {
      var s = r && (f && r[f] || r[p]);
      if (typeof s == "function")
        return s;
    }
    var C = "<<anonymous>>", M = {
      array: k("array"),
      bigint: k("bigint"),
      bool: k("boolean"),
      func: k("function"),
      number: k("number"),
      object: k("object"),
      string: k("string"),
      symbol: k("symbol"),
      any: z(),
      arrayOf: I,
      element: A(),
      elementType: a(),
      instanceOf: W,
      node: B(),
      objectOf: G,
      oneOf: X,
      oneOfType: Z,
      shape: ee,
      exact: re
    };
    function L(r, s) {
      return r === s ? r !== 0 || 1 / r === 1 / s : r !== r && s !== s;
    }
    function P(r, s) {
      this.message = r, this.data = s && typeof s == "object" ? s : {}, this.stack = "";
    }
    P.prototype = Error.prototype;
    function $(r) {
      if (process.env.NODE_ENV !== "production")
        var s = {}, b = 0;
      function m(E, v, h, T, _, g, D) {
        if (T = T || C, g = g || h, D !== n) {
          if (R) {
            var o = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw o.name = "Invariant Violation", o;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var Y = T + ":" + h;
            !s[Y] && // Avoid spamming the console because they are often not actionable except for lib authors
            b < 3 && (c(
              "You are manually calling a React.PropTypes validation function for the `" + g + "` prop on `" + T + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), s[Y] = !0, b++);
          }
        }
        return v[h] == null ? E ? v[h] === null ? new P("The " + _ + " `" + g + "` is marked as required " + ("in `" + T + "`, but its value is `null`.")) : new P("The " + _ + " `" + g + "` is marked as required in " + ("`" + T + "`, but its value is `undefined`.")) : null : r(v, h, T, _, g);
      }
      var y = m.bind(null, !1);
      return y.isRequired = m.bind(null, !0), y;
    }
    function k(r) {
      function s(b, m, y, E, v, h) {
        var T = b[m], _ = q(T);
        if (_ !== r) {
          var g = U(T);
          return new P(
            "Invalid " + E + " `" + v + "` of type " + ("`" + g + "` supplied to `" + y + "`, expected ") + ("`" + r + "`."),
            { expectedType: r }
          );
        }
        return null;
      }
      return $(s);
    }
    function z() {
      return $(l);
    }
    function I(r) {
      function s(b, m, y, E, v) {
        if (typeof r != "function")
          return new P("Property `" + v + "` of component `" + y + "` has invalid PropType notation inside arrayOf.");
        var h = b[m];
        if (!Array.isArray(h)) {
          var T = q(h);
          return new P("Invalid " + E + " `" + v + "` of type " + ("`" + T + "` supplied to `" + y + "`, expected an array."));
        }
        for (var _ = 0; _ < h.length; _++) {
          var g = r(h, _, y, E, v + "[" + _ + "]", n);
          if (g instanceof Error)
            return g;
        }
        return null;
      }
      return $(s);
    }
    function A() {
      function r(s, b, m, y, E) {
        var v = s[b];
        if (!d(v)) {
          var h = q(v);
          return new P("Invalid " + y + " `" + E + "` of type " + ("`" + h + "` supplied to `" + m + "`, expected a single ReactElement."));
        }
        return null;
      }
      return $(r);
    }
    function a() {
      function r(s, b, m, y, E) {
        var v = s[b];
        if (!e.isValidElementType(v)) {
          var h = q(v);
          return new P("Invalid " + y + " `" + E + "` of type " + ("`" + h + "` supplied to `" + m + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return $(r);
    }
    function W(r) {
      function s(b, m, y, E, v) {
        if (!(b[m] instanceof r)) {
          var h = r.name || C, T = ne(b[m]);
          return new P("Invalid " + E + " `" + v + "` of type " + ("`" + T + "` supplied to `" + y + "`, expected ") + ("instance of `" + h + "`."));
        }
        return null;
      }
      return $(s);
    }
    function X(r) {
      if (!Array.isArray(r))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? c(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : c("Invalid argument supplied to oneOf, expected an array.")), l;
      function s(b, m, y, E, v) {
        for (var h = b[m], T = 0; T < r.length; T++)
          if (L(h, r[T]))
            return null;
        var _ = JSON.stringify(r, function(D, o) {
          var Y = U(o);
          return Y === "symbol" ? String(o) : o;
        });
        return new P("Invalid " + E + " `" + v + "` of value `" + String(h) + "` " + ("supplied to `" + y + "`, expected one of " + _ + "."));
      }
      return $(s);
    }
    function G(r) {
      function s(b, m, y, E, v) {
        if (typeof r != "function")
          return new P("Property `" + v + "` of component `" + y + "` has invalid PropType notation inside objectOf.");
        var h = b[m], T = q(h);
        if (T !== "object")
          return new P("Invalid " + E + " `" + v + "` of type " + ("`" + T + "` supplied to `" + y + "`, expected an object."));
        for (var _ in h)
          if (i(h, _)) {
            var g = r(h, _, y, E, v + "." + _, n);
            if (g instanceof Error)
              return g;
          }
        return null;
      }
      return $(s);
    }
    function Z(r) {
      if (!Array.isArray(r))
        return process.env.NODE_ENV !== "production" && c("Invalid argument supplied to oneOfType, expected an instance of array."), l;
      for (var s = 0; s < r.length; s++) {
        var b = r[s];
        if (typeof b != "function")
          return c(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + Q(b) + " at index " + s + "."
          ), l;
      }
      function m(y, E, v, h, T) {
        for (var _ = [], g = 0; g < r.length; g++) {
          var D = r[g], o = D(y, E, v, h, T, n);
          if (o == null)
            return null;
          o.data && i(o.data, "expectedType") && _.push(o.data.expectedType);
        }
        var Y = _.length > 0 ? ", expected one of type [" + _.join(", ") + "]" : "";
        return new P("Invalid " + h + " `" + T + "` supplied to " + ("`" + v + "`" + Y + "."));
      }
      return $(m);
    }
    function B() {
      function r(s, b, m, y, E) {
        return N(s[b]) ? null : new P("Invalid " + y + " `" + E + "` supplied to " + ("`" + m + "`, expected a ReactNode."));
      }
      return $(r);
    }
    function H(r, s, b, m, y) {
      return new P(
        (r || "React class") + ": " + s + " type `" + b + "." + m + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + y + "`."
      );
    }
    function ee(r) {
      function s(b, m, y, E, v) {
        var h = b[m], T = q(h);
        if (T !== "object")
          return new P("Invalid " + E + " `" + v + "` of type `" + T + "` " + ("supplied to `" + y + "`, expected `object`."));
        for (var _ in r) {
          var g = r[_];
          if (typeof g != "function")
            return H(y, E, v, _, U(g));
          var D = g(h, _, y, E, v + "." + _, n);
          if (D)
            return D;
        }
        return null;
      }
      return $(s);
    }
    function re(r) {
      function s(b, m, y, E, v) {
        var h = b[m], T = q(h);
        if (T !== "object")
          return new P("Invalid " + E + " `" + v + "` of type `" + T + "` " + ("supplied to `" + y + "`, expected `object`."));
        var _ = t({}, b[m], r);
        for (var g in _) {
          var D = r[g];
          if (i(r, g) && typeof D != "function")
            return H(y, E, v, g, U(D));
          if (!D)
            return new P(
              "Invalid " + E + " `" + v + "` key `" + g + "` supplied to `" + y + "`.\nBad object: " + JSON.stringify(b[m], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(r), null, "  ")
            );
          var o = D(h, g, y, E, v + "." + g, n);
          if (o)
            return o;
        }
        return null;
      }
      return $(s);
    }
    function N(r) {
      switch (typeof r) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !r;
        case "object":
          if (Array.isArray(r))
            return r.every(N);
          if (r === null || d(r))
            return !0;
          var s = w(r);
          if (s) {
            var b = s.call(r), m;
            if (s !== r.entries) {
              for (; !(m = b.next()).done; )
                if (!N(m.value))
                  return !1;
            } else
              for (; !(m = b.next()).done; ) {
                var y = m.value;
                if (y && !N(y[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function te(r, s) {
      return r === "symbol" ? !0 : s ? s["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && s instanceof Symbol : !1;
    }
    function q(r) {
      var s = typeof r;
      return Array.isArray(r) ? "array" : r instanceof RegExp ? "object" : te(s, r) ? "symbol" : s;
    }
    function U(r) {
      if (typeof r > "u" || r === null)
        return "" + r;
      var s = q(r);
      if (s === "object") {
        if (r instanceof Date)
          return "date";
        if (r instanceof RegExp)
          return "regexp";
      }
      return s;
    }
    function Q(r) {
      var s = U(r);
      switch (s) {
        case "array":
        case "object":
          return "an " + s;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + s;
        default:
          return s;
      }
    }
    function ne(r) {
      return !r.constructor || !r.constructor.name ? C : r.constructor.name;
    }
    return M.checkPropTypes = u, M.resetWarningCache = u.resetWarningCache, M.PropTypes = M, M;
  }, ue;
}
var fe, Pe;
function sr() {
  if (Pe)
    return fe;
  Pe = 1;
  var e = pe();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, fe = function() {
    function i(l, d, R, f, p, w) {
      if (w !== e) {
        var C = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw C.name = "Invariant Violation", C;
      }
    }
    i.isRequired = i;
    function u() {
      return i;
    }
    var c = {
      array: i,
      bigint: i,
      bool: i,
      func: i,
      number: i,
      object: i,
      string: i,
      symbol: i,
      any: i,
      arrayOf: u,
      element: i,
      elementType: i,
      instanceOf: u,
      node: i,
      objectOf: u,
      oneOf: u,
      oneOfType: u,
      shape: u,
      exact: u,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return c.PropTypes = c, c;
  }, fe;
}
if (process.env.NODE_ENV !== "production") {
  var cr = $e(), ur = !0;
  le.exports = ir()(cr.isElement, ur);
} else
  le.exports = sr()();
var fr = le.exports;
const O = /* @__PURE__ */ Me(fr), j = O.oneOfType([O.string, O.number]), ye = {
  all: O.bool,
  grid: O.bool,
  aural: O.bool,
  braille: O.bool,
  handheld: O.bool,
  print: O.bool,
  projection: O.bool,
  screen: O.bool,
  tty: O.bool,
  tv: O.bool,
  embossed: O.bool
}, De = {
  orientation: O.oneOf(["portrait", "landscape"]),
  scan: O.oneOf(["progressive", "interlace"]),
  aspectRatio: O.string,
  deviceAspectRatio: O.string,
  height: j,
  deviceHeight: j,
  width: j,
  deviceWidth: j,
  color: O.bool,
  colorIndex: O.bool,
  monochrome: O.bool,
  resolution: j,
  type: Object.keys(ye)
}, { type: wr, ...lr } = De, Le = {
  minAspectRatio: O.string,
  maxAspectRatio: O.string,
  minDeviceAspectRatio: O.string,
  maxDeviceAspectRatio: O.string,
  minHeight: j,
  maxHeight: j,
  minDeviceHeight: j,
  maxDeviceHeight: j,
  minWidth: j,
  maxWidth: j,
  minDeviceWidth: j,
  maxDeviceWidth: j,
  minColor: O.number,
  maxColor: O.number,
  minColorIndex: O.number,
  maxColorIndex: O.number,
  minMonochrome: O.number,
  maxMonochrome: O.number,
  minResolution: j,
  maxResolution: j,
  ...lr
}, dr = { ...ye, ...Le };
var pr = {
  all: dr,
  types: ye,
  matchers: De,
  features: Le
};
const yr = (e) => `not ${e}`, vr = (e, t) => {
  const n = Ie(e);
  return typeof t == "number" && (t = `${t}px`), t === !0 ? n : t === !1 ? yr(n) : `(${n}: ${t})`;
}, mr = (e) => e.join(" and "), hr = (e) => {
  const t = [];
  return Object.keys(pr.all).forEach((n) => {
    const i = e[n];
    i != null && t.push(vr(n, i));
  }), mr(t);
}, br = qe(void 0), Er = (e) => e.query || hr(e), Ce = (e) => e ? Object.keys(e).reduce((n, i) => (n[Ie(i)] = e[i], n), {}) : void 0, ke = () => {
  const e = Ye(!1);
  return F(() => {
    e.current = !0;
  }, []), e.current;
}, Tr = (e) => {
  const t = We(br), n = () => Ce(e) || Ce(t), [i, u] = J(n);
  return F(() => {
    const c = n();
    rr(i, c) || u(c);
  }, [e, t]), i;
}, gr = (e) => {
  const t = () => Er(e), [n, i] = J(t);
  return F(() => {
    const u = t();
    n !== u && i(u);
  }, [e]), n;
}, Or = (e, t) => {
  const n = () => Ge(e, t || {}, !!t), [i, u] = J(n), c = ke();
  return F(() => {
    if (c) {
      const l = n();
      return u(l), () => {
        l && l.dispose();
      };
    }
  }, [e, t]), i;
}, Rr = (e) => {
  const [t, n] = J(e.matches);
  return F(() => {
    const i = (u) => {
      n(u.matches);
    };
    return e.addListener(i), n(e.matches), () => {
      e.removeListener(i);
    };
  }, [e]), t;
}, xr = (e, t, n) => {
  const i = Tr(t), u = gr(e);
  if (!u)
    throw new Error("Invalid or missing MediaQuery!");
  const c = Or(u, i), l = Rr(c), d = ke();
  return F(() => {
    d && n && n(l);
  }, [l]), F(() => () => {
    c && c.dispose();
  }, []), l;
}, Pr = () => xr({ minWidth: 756 });
export {
  Pr as default
};
